export default function Icon404(props: Icon) {
  const { height, width } = props;
  return (
    <svg
      aria-hidden="true"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : height ? height : 406}
      height={height ? height : width ? width : 512}
      viewBox="0 0 406 512"
    >
      <g data-name="404_icon">
        <path
          fill="#2c0313"
          d="M55.6 82.5h151a7.5 7.5 0 0 0 0-15h-151a7.5 7.5 0 0 0 0 15Z"
          data-name="Path 58"
        />
        <path
          fill="#2c0313"
          d="M55.6 131.9h151a7.5 7.5 0 0 0 0-15h-151a7.5 7.5 0 0 0 0 15Z"
          data-name="Path 59"
        />
        <path
          fill="#73002d"
          d="M144.9 268.2c0-3.6-4.7-5.8-7.6-5.8a7.288 7.288 0 0 0-6.6 4.1l-34.5 68a6.127 6.127 0 0 0-.9 3.1 5.23 5.23 0 0 0 5.3 5.6h35.1v18.4c0 3.3 3.7 5 7.6 5 3.7 0 7.6-1.7 7.6-5v-18.4h7c2.7 0 5.1-3.6 5.1-7 0-3.6-1.7-7.1-5.1-7.1h-7v-19.7c0-3.6-3.9-5-7.6-5-3.9 0-7.6 1.4-7.6 5v19.7h-21l29.4-58.6a4.883 4.883 0 0 0 .8-2.3Z"
          data-name="Path 60"
        />
        <path
          fill="#73002d"
          d="M235.2 335.7v-41.5c0-23.1-14.1-31.8-32.1-31.8-18.1 0-31.9 8.7-31.9 31.8v41.5c0 23.1 13.8 31.8 31.9 31.8 17.9 0 32.1-8.7 32.1-31.8Zm-49 0v-41.5c0-12.5 6.1-18.4 16.8-18.4 10.6 0 17 5.8 17 18.4v41.5c0 12.5-6.4 18.4-17 18.4s-16.8-5.9-16.8-18.4Z"
          data-name="Path 61"
        />
        <path
          fill="#73002d"
          d="M292.2 268.2c0-3.6-4.7-5.8-7.6-5.8a7.288 7.288 0 0 0-6.6 4.1l-34.5 68a6.127 6.127 0 0 0-.9 3.1 5.23 5.23 0 0 0 5.3 5.6H283v18.4c0 3.3 3.7 5 7.6 5 3.7 0 7.6-1.7 7.6-5v-18.4h7c2.7 0 5.1-3.6 5.1-7 0-3.6-1.7-7.1-5.1-7.1h-7v-19.7c0-3.6-3.9-5-7.6-5-3.9 0-7.6 1.4-7.6 5v19.7h-21l29.4-58.6a4.883 4.883 0 0 0 .8-2.3Z"
          data-name="Path 62"
        />
        <path
          fill="#2c0313"
          d="M403.8 118.9 287 2.2a7.493 7.493 0 0 0-5.3-2.2H34A34.035 34.035 0 0 0 0 34v444a34.035 34.035 0 0 0 34 34h338a34.035 34.035 0 0 0 34-34V124.2a7.857 7.857 0 0 0-2.2-5.3ZM289.2 25.6l91.1 91.1h-78.6a12.5 12.5 0 0 1-12.5-12.5V25.6ZM391 478a18.992 18.992 0 0 1-19 19H34a18.992 18.992 0 0 1-19-19V34a18.992 18.992 0 0 1 19-19h240.2v89.2a27.484 27.484 0 0 0 27.5 27.5H391Z"
          data-name="Path 63"
        />
        <path
          fill="#2c0313"
          d="M350.4 328.9a7.555 7.555 0 0 0-7.5 7.5v68.4a12.611 12.611 0 0 1-12.6 12.6H75.7a12.611 12.611 0 0 1-12.6-12.6v-68.4a7.5 7.5 0 0 0-15 0v68.4a27.655 27.655 0 0 0 27.6 27.6h254.6a27.655 27.655 0 0 0 27.6-27.6v-68.4a7.427 7.427 0 0 0-7.5-7.5Z"
          data-name="Path 64"
        />
        <path
          fill="#2c0313"
          d="M48.1 225.9v75.6a7.5 7.5 0 0 0 15 0v-75.6a12.611 12.611 0 0 1 12.6-12.6h254.6a12.611 12.611 0 0 1 12.6 12.6v75.6a7.5 7.5 0 0 0 15 0v-75.6a27.655 27.655 0 0 0-27.6-27.6H75.7a27.464 27.464 0 0 0-27.6 27.6Z"
          data-name="Path 65"
        />
      </g>
    </svg>
  );
}
